import { Component, OnInit, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CourseCardComponent } from '../../../courses/components/course-card/course-card.component';
import { InfoBannerComponent } from '../../../../shared/components/ui/info-banner/info-banner.component';
import { HomeEmptyStateComponent } from '../home-empty-state/home-empty-state.component';
import { HomeDataService } from '../../services/home-data.service';

@Component({
  selector: 'app-courses-grid',
  standalone: true,
  imports: [
    CourseCardComponent,
    InfoBannerComponent,
    HomeEmptyStateComponent,
  ],
  templateUrl: './courses-grid.component.html',
  styleUrl: './courses-grid.component.scss',
})
export class CoursesGridComponent implements OnInit {
  #router = inject(Router);
  #homeData = inject(HomeDataService);

  readonly skeletonItems = [1, 2, 3, 4, 5, 6];

  courses = computed(() => this.#homeData.courses());
  isLoading = computed(() => this.#homeData.coursesLoading());
  isEmpty = computed(() => !this.isLoading() && this.courses().length === 0);

  ngOnInit(): void {
    this.#homeData.prefetchCoursesSummary();
    this.#homeData.prefetchCourses();
  }

  openCourse(courseId: string): void {
    this.#router.navigate(['/home/courses', courseId]);
  }
}
